import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="flex flex-col relative">
            <img className="w-100-px w-[200px] h-[200px] absolute bottom-0 left-[-35px]" src={require("../../assets/icons/footer-1.svg").default} alt="" />
            <img className="absolute w-100-px right-0 w-[200px] h-[200px]" src={require("../../assets/icons/footer-2.svg").default} alt="" />
            <div className="container h-[50vh] flex flex-col items-center justify-center relative gap-10">
                <Link to={"/"} className="flex items-center justify-center">
                    <img className="w-[200px] h-[200px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                </Link>
                <nav className="hidden md:block">
                    <ul className="flex items-center gap-[10px]">
                        {[
                            { path: "/", label: "Home" },
                            { path: "/portfolio", label: "Portfolio" },
                            { path: "/services", label: "Services" },
                            { path: "/contact", label: "Contact us" },
                        ].map((item) => (
                            <li key={item.path}>
                                <NavLink
                                    to={item.path}
                                    className={`px-4 py-2 font-bold capitalize transition duration-500 text-white hover:text-[#016E82]`}

                                >
                                    {t(item.label)}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="flex items-center gap-[8px]">
                    <Link to={"/"} className="bg-[#282828] flex items-center justify-center rounded-full w-[45px] h-[45px]">
                        <img className="w-[25px] h-[25px]" src={require("../../assets/icons/facebook.svg").default} alt="" />
                    </Link>
                    <Link to={"/"} className="bg-[#282828] flex items-center justify-center rounded-full w-[45px] h-[45px]">
                        <img className="w-[25px] h-[25px]" src={require("../../assets/icons/instagram.svg").default} alt="" />
                    </Link>
                    <Link to={"/"} className="bg-[#282828] flex items-center justify-center rounded-full w-[45px] h-[45px]">
                        <img className="w-[25px] h-[25px]" src={require("../../assets/icons/email.svg").default} alt="" />
                    </Link>
                </div>
            </div>
            <div className="text-white text-center bg-black py-[15px]">{t("© 2025 All Rights Reserved. For Aqaba Seasons")}</div>
        </footer >
    );
}